function isErrorWithMessage(err: unknown): err is { message: string } {
  if (typeof err !== 'object' || err === null) return false;

  const value = Reflect.get(err, 'message');

  return typeof value === 'string';
}

export function getErrorMessage(
  err: unknown,
  defaultMessage = 'Something went wrong. Please try again.'
): string {
  if (isErrorWithMessage(err)) {
    return err.message;
  }

  return defaultMessage;
}
